"use client";

export type UploadedMediaKind = "audio" | "video";

export const revokeBlobAudioUrl = (url: string | null) => {
  if (url?.startsWith("blob:")) {
    URL.revokeObjectURL(url);
  }
};

export const getTranscriptionErrorStatus = (error: unknown) =>
  error instanceof Error ? error.message : "transcribe_failed";

export const getUrlDisplayName = (url: string) => url.split("/").pop()?.split("?")[0] || url;

export function getSttHeroContentAnalyticsProps(uploadFileName: string | null, selectedIndex: number) {
  if (uploadFileName !== null) {
    return { content_type: "user_upload" as const };
  }
  return { content_type: "example" as const, example_index: selectedIndex };
}
